import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import {getDarkBrandColor, getFoldDoNotCutText} from "../../utils/themePdfUtils";

function FoldLabelHorizontal(props) {
    const noCutStyle = {
        position: "absolute",
        backgroundColor: "white",
        textTransform: "uppercase",
        paddingHorizontal: "2px",
        fontWeight: "bold",
        top: "-3.75px",
        fontSize: "5px",
        color: getDarkBrandColor()
    }

    return (
        <View style={{
            position: "relative",
            height: 0,
        }}>
            {props.offsets.map((offset, index) => {
                const style = {...noCutStyle};
                style[offset.side] = offset.value;

                return (
                    <Text key={index} style={style}>
                        {getFoldDoNotCutText()}
                    </Text>
                )
            }
            )}
        </View>
    );
}

export default FoldLabelHorizontal;